import Page from './emails.page.vue'

let routes = [
  {
    path: 'emails',
    name: 'emails',
    component: Page
  },
]

export default routes
